module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oEB2wY/tc-custom/9781399018012.jpg?1718183454122",
      "alt": "This image is the cover for the book Panzer III, German Army Light Tank, TankCraft"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Panzer III, German Army Light Tank, TankCraft\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Pzkpfw Ill was the most effective tank available to the German army in North Africa during the battles of 1941. It outnumbered all the other types in service with the Afrikakorps at that time and when compared to the Pzkpfw I and Pzkpfw II designs it was a potent, modern weapons system. Although less heavily armored than its British opponents it was sturdy and reliable and its main armament was the equal of any enemy anti-tank gun it was called upon to face. This volume of the TankCraft series, the first of two parts, examines the story of the tank's North African service beginning with the arrival of Panzer-Regiment 5 in Tripoli and ending with the advance to El Alamein in late 1942. Dennis Oliver uses archive photos and extensively researched color illustrations to examine the Pzkpfw Ill and the Panzer units that took part in the early battles in North Africa. A key section of his book displays available model kits and aftermarket products, complemented by a gallery of beautifully constructed and painted models in various scales. Technical details as well as modifications introduced during production and in the field are also examined, providing everything the modeler needs to recreate an accurate representation of these historic tanks.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dennis Oliver\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Dennis Oliver is the author of over twenty books on Second World War armored vehicles.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword Military\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0